import React from "react"
import { useIntl } from "react-intl"
import { Box, Typography } from "@carrotfertility/carotene-core"
import { FormSelect, FormSelectOption } from "@carrotfertility/carotene-core-x"
import { HelpfulRating } from "./FeedbackContainer"

interface FeedbackSelectProps {
  helpfulRating: HelpfulRating | ""
}

export function FeedbackSelect({ helpfulRating }: FeedbackSelectProps): JSX.Element {
  const intl = useIntl()

  const helpfulFeedbackOptions: FormSelectOption[] = [
    {
      value: "CLEAR_EASY_TO_UNDERSTAND",
      label: intl.formatMessage({ defaultMessage: "Clear and easy to understand" })
    },
    {
      value: "DETAILED_INFORMATIVE",
      label: intl.formatMessage({ defaultMessage: "Detailed and informative" })
    },
    {
      value: "TRUSTWORTHY",
      label: intl.formatMessage({ defaultMessage: "Trustworthy" })
    },
    {
      value: "ANSWERED_QUESTION",
      label: intl.formatMessage({ defaultMessage: "Answered my question" })
    },
    {
      value: "RELEVANT",
      label: intl.formatMessage({ defaultMessage: "Relevant to me" })
    },
    {
      value: "SOMETHING_ELSE",
      label: intl.formatMessage({ defaultMessage: "Something else" })
    }
  ]

  const notHelpfulFeedbackOptions: FormSelectOption[] = [
    {
      value: "CONFUSING_UNCLEAR",
      label: intl.formatMessage({ defaultMessage: "Confusing or unclear" })
    },
    {
      value: "TOO_BASIC_MISSING_DETAILS",
      label: intl.formatMessage({ defaultMessage: "Too basic or missing details" })
    },
    {
      value: "TOO_LONG",
      label: intl.formatMessage({ defaultMessage: "Too long" })
    },
    {
      value: "NOT_TRUSTWORTHY_ACCURATE",
      label: intl.formatMessage({ defaultMessage: "Didn't feel trustworthy or accurate" })
    },
    {
      value: "DIDNT_ANSWER_QUESTION",
      label: intl.formatMessage({ defaultMessage: "Didn't answer my question" })
    },
    {
      value: "NOT_RELEVANT",
      label: intl.formatMessage({ defaultMessage: "Not relevant to me" })
    },
    {
      value: "SOMETHING_ELSE",
      label: intl.formatMessage({ defaultMessage: "Something else" })
    }
  ]

  if (!helpfulRating) {
    return <></>
  }

  return (
    <Box>
      <FormSelect
        name="memberFeedbackSelections"
        label={intl.formatMessage({ defaultMessage: "Please select reasons" })}
        renderValue={(value: unknown): React.ReactNode => {
          const defaultPlaceholderText = intl.formatMessage({ defaultMessage: "Select an option" })
          if (!Array.isArray(value) || !value.length) {
            return (
              <Typography component="span" color={(theme) => theme.palette.placeholder}>
                {defaultPlaceholderText}
              </Typography>
            )
          }
          const allOptions = [...helpfulFeedbackOptions, ...notHelpfulFeedbackOptions]

          return value.map((val) => allOptions.find((option) => option.value === val)?.label || val).join(", ")
        }}
        multiple={true}
        options={helpfulRating === HelpfulRating.WAS_HELPFUL ? helpfulFeedbackOptions : notHelpfulFeedbackOptions}
        fullWidth
        sx={(theme) => ({
          marginBlockEnd: theme.tokens.spacing.lg
        })}
      />
    </Box>
  )
}
